import React from 'react';
import PageHeader from '../components/ui/PageHeader';
import SectionHeading from '../components/ui/SectionHeading';
import { pricingData } from '../data/content';
import Button from '../components/ui/Button';

const PricingTable = ({ title, items }) => (
  <div className="mb-12">
    <h3 className="font-serif text-2xl mb-6 text-veloura-text border-b border-veloura-primary/50 pb-4">{title}</h3>
    <ul className="space-y-4">
      {items.map((item, index) => (
        <li key={index} className="flex justify-between items-center text-lg">
          <span className="text-veloura-muted">{item.name}</span>
          <span className="font-medium text-veloura-text">{item.price}</span>
        </li>
      ))}
    </ul>
  </div>
);

const Pricing = () => {
  return (
    <div className="bg-veloura-bg min-h-screen">
      <PageHeader title="Pricing" bgImage="https://images.unsplash.com/photo-1522337660859-02fbefca4702?auto=format&fit=crop&q=80&w=2000" />
      
      <div className="container mx-auto px-6 max-w-4xl py-24">
        <SectionHeading title="Studio Pricing" subtitle="Transparent Rates" />
        
        <div className="bg-white p-8 md:p-12 rounded-[2rem] shadow-sm border border-veloura-primary/20">
          
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <PricingTable title="New Sets" items={pricingData.newSets} />
              <PricingTable title="Add-ons & Extras" items={pricingData.addons} />
            </div>
            <div>
              <PricingTable title="Refills (Fills)" items={pricingData.refills} />
              
              <div className="bg-veloura-primary/20 p-6 rounded-xl mt-8">
                <h4 className="font-serif text-xl mb-3 text-veloura-text">Important Note</h4>
                <p className="text-sm text-veloura-muted leading-relaxed">
                  Pricing varies slightly depending on natural lash condition, density, and desired fullness. A true assessment can only be made in-studio. Refills require at least 40% of extensions remaining; otherwise, a full set will be charged.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12 pt-12 border-t border-veloura-primary/30">
            <Button to="/book" variant="primary" className="px-10">Book Your Session</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;